import { DOCUMENT } from '@angular/common';
import { Component, inject, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { wrapValue } from '../../mailgun/wrap-value';
import {
  TemplateComponentClass,
  TemplateDataMock,
} from '../../providers/template-definition.provider';
import { TemplateRendererConfig } from '../../providers/template-renderer-config';

@Component({
  standalone: true,
  template: ``,
  encapsulation: ViewEncapsulation.None,
})
export class EmailTemplateRendererComponent {
  public config = inject(TemplateRendererConfig);
  public templateData = inject(TemplateDataMock);
  public templateCmpClass = inject(TemplateComponentClass);
  public vcRef = inject(ViewContainerRef);
  public doc = inject(DOCUMENT);

  public ngOnInit() {
    const cmpRef = this.vcRef.createComponent(this.templateCmpClass);
    cmpRef.setInput('data', wrapValue('', this.templateData, this.config));
  }
}
